import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import * as jnb from 'react-bootstrap';
import PublicHeader from '../Header/PublicHeader';



export default function CessPayment() {
    const base64Decode = (base64String) => {
        return atob(base64String);
      };
    const query = new URLSearchParams(useLocation().search);
    const msg = base64Decode(query.get('msg'));
    const paymentvalues = msg.split("###"); //split using ### 

  const [paymentDate, paymentTime] = paymentvalues[3].split(" ");

    let navigate = useNavigate();
  //[LBTEST1746423783125,100,Success,2025-05-05 11:13:14]
    // show response as per your format
  const rawDate = paymentvalues[3].split(" ")[0]; // "2025-05-09"
  const [year, month, day] = rawDate.split("-");
  const paymentDatee = `${day}-${month}-${year}`;
  return (<>
    {/* <div>PaymentResponse msg</div>
    {msg}
    <div>PaymentResponse</div>
    {paymentvalues} */}
    {/*
    transaction_id : LBTEST1746423783125
    transaction_amount : 100
    payment_status : Success/ Fail
    transaction_date : 2025-05-05 11:13:14
     */}
  <PublicHeader/>
  <div className="main_section">  </div>
    <jnb.Container className="mt-1">
    <jnb.Row>
                  <jnb.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing d-flex justify-content-between px-0">
<div className="inner-herbpage-service-title1">
                        <h1>Payment Details </h1>
                    </div>
                      <div className="text-right">
                    <button className="btn btn-secondary btn-sm" onClick={() => { navigate('/CESSPaymentScreen') }}>Back</button>
                    </div>
                    </jnb.Col>
                    </jnb.Row>
                    </jnb.Container>
  {/* <CommonPageHeading heading="Payment Details" /> */}
  <jnb.Container className="outer-page-content-container">
  <div className='text-center mx-5'>
       
                                 <jnb.Row className="pt-1">
                                    
                                     {/* <div className="table-responsive">
                                         <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-2"
                                             style={{ border: '3px solid lightblue', width: '100%', borderCollapse: 'collapse', }}
                                         >
                                             <thead style={{ border: "1px solid black" }}>
     
                                                 
                                             </thead>
                                             <tbody>
                                                 <tr>
                                                  <td></td>
                                                     <td>1.</td>
                                                     <td>XXX</td>
                                                     <td>XX-XX-XX</td>
                                                     <td>ABC</td>
                                                 </tr>
                                             </tbody>
                                         </table>
                                     </div> */}
                                 <div className="d-flex justify-content-center align-items-center">
                                 <div className="table-responsive" style={{ width: '60%' }}>
  <table
    className="table table-bordered table-striped table-hover mb-0 mt-4"
    style={{
      border: '3px solid lightblue',
      width: '100%',
      borderCollapse: 'collapse',
    }}
  >
    <thead>
      <tr>
      <th
  colSpan="2"
  className="text-center"
  style={{
    fontSize: '1.2rem',
    backgroundColor: '7px solid lightblue',
    color: 'black',
    border: '1px solid black', 
  }}
>
  Payment Invoice
</th>

      </tr>
    </thead>
    <tbody>
      <tr>
        <th style={{ width: '50%' }}>Transaction ID</th>
        <td>{paymentvalues[0]}</td>
      </tr>
      <tr>
        <th>Amount</th>
        <td>₹{paymentvalues[1]}</td>
      </tr>
      <tr>
        <th>Payment Status</th>
        <td style={{ color: paymentvalues[2] === 'SUCCESS' ? 'green' : 'red' }}>
  {paymentvalues[2]}
</td>

      </tr>
      <tr>
        <th>Payment Date & Time </th>
        <td>{paymentDatee} & {paymentTime} </td>
      </tr>
      {/* <tr>
        <th>Payment Time</th>
        <td>{paymentTime}</td>
      </tr> */}
    </tbody>
  </table>
</div>

</div>

     
                                 </jnb.Row>
                                 </div>
                                 </jnb.Container>
                                
    </>)
}